const selectTime = (state: { timekeeper: string }) => state.timekeeper;

export default selectTime;
